import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../common/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceModule } from '../service/service.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ContactDataListComponent } from './contact-data-list/contact-data-list.component';
import { ContactDataPageComponent } from './contact-data-page/contact-data-page.component';
import { ContactDataRoutingModule } from './contact-data-routing.module';
import { LabeledTextboxModule } from '../common/material/components/labeled-textbox/labeled-textbox.module';

@NgModule({ declarations: [
    ContactDataListComponent,
    ContactDataPageComponent,
], imports: [
    CommonModule,
    MaterialModule,
    ServiceModule,
    ContactDataRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LabeledTextboxModule,
], providers: [
    provideHttpClient(withInterceptorsFromDi()),
] })
export class ContactDataModule {
}
